module.exports = __webpack_public_path__ + "media/bootstrap-icons/save-caf304b7.svg";